import { useCallback, useEffect, useState } from 'react';
import { useRecoilState } from 'recoil';
import { toast } from 'material-react-toastify';
import { userSummaryAtom } from '../atoms/UserSummary';
import { getMe } from '../api/Auth';
import { isTokenValid } from '../utils/Auth';

export const useUserSummary = () => {
  const [loading, setLoading] = useState(false);
  const [userSummary, setUserSummary] = useRecoilState(userSummaryAtom);

  const refreshUserSummary = useCallback(() => {
    setLoading(true);
    getMe()
      .then(setUserSummary)
      .catch((err) => toast.error(err.message))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    if (isTokenValid() && !userSummary) {
      refreshUserSummary();
    }
  }, [userSummary]);

  return {
    userSummary,
    loading,
    refreshUserSummary,
  };
};
